/**
 * Auth Strategy for Job Ads Web Component
 * Creates token strategy for API authentication via local proxy
 * The server proxy forwards to service-resource-api
 */

export const createAuthStrategy = () => {
  const tesUi = (window as any).tesUi;

  if (!tesUi || !tesUi.tokenStrategies) {
    console.warn('tesUi.tokenStrategies not available');
    return null;
  }

  // /resource-detail/api is the gateway-routed prefix for this app's own token proxy.
  const tokenStrategy = new tesUi.tokenStrategies.api({
    basePath: '/api'
  });

  tokenStrategy.fetchWithAuth = tokenStrategy.fetchWithAuth.bind(tokenStrategy);
  tokenStrategy.fetch = tokenStrategy.fetch.bind(tokenStrategy);

  return tokenStrategy;
};
